import Typography, { ETypo, ETypoColor } from "@Front/Components/DesignSystem/Typography";
import SearchBlockList from "@Front/Components/DesignSystem/SearchBlockList";
import type { IBlock } from "@Front/Components/DesignSystem/SearchBlockList/BlockList/Block";
import type { OfficeChoiceEntry } from "@Front/Components/Layouts/Login/helpers/loginCustomerMultiCandidateRouting";
import classes from "@Front/Components/Layouts/Login/classes.module.scss";
import { useMemo } from "react";

type Props = {
	offices: OfficeChoiceEntry[];
	onSelectOffice: (officeUid: string) => void;
	isSubmitting: boolean;
};

export default function StepCustomerOfficeChoice(props: Props): React.JSX.Element {
	const { offices, onSelectOffice, isSubmitting } = props;
	const blocks: IBlock[] = useMemo(
		() =>
			offices.map((o) => ({
				id: o.officeUid,
				primaryText: o.officeName,
				secondaryText: o.folderCount > 1 ? `${o.folderCount} dossiers` : "1 dossier",
			})),
		[offices],
	);

	const handleBlock = (block: IBlock): void => {
		if (isSubmitting) return;
		onSelectOffice(block.id);
	};

	return (
		<div className={classes["root"]}>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY} className={classes["disambiguation-hint"]}>
				Plusieurs études correspondent à cet e-mail. Choisissez celle pour laquelle vous vous connectez ; le choix du dossier se fait
				ensuite dans votre espace client lorsque plusieurs dossiers sont rattachés au même compte.
			</Typography>
			<div className={classes["disambiguation-list"]}>
				<SearchBlockList blocks={blocks} onSelectedBlock={handleBlock} fullwidth />
			</div>
		</div>
	);
}
